const layoutTypes = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

const layoutWidthTypes = {
  FLUID: "fluid",
  BOXED: "boxed",
  SCROLLABLE: "scrollable",
};

const topBarThemeTypes = {
  LIGHT: "light",
  DARK: "dark",
  COLORED: "colored",
};

const leftBarThemeImageTypes = {
  NONE: "none",
  IMG1: "img1",
  IMG2: "img2",
  IMG3: "img3",
  IMG4: "img4",
};

const leftSidebarTypes = {
  DEFAULT: "default",
  COMPACT: "compact",
  ICON: "icon",
};

const leftSideBarThemeTypes = {
  LIGHT: "light",
  COLORED: "colored",
  DARK: "dark",
  WINTER: "winter",
  LADYLIP: "ladylip",
  PLUMPLATE: "plumplate",
  STRONGBLISS: "strongbliss",
  GREATWHALE: "greatwhale",
};

const MENU_CODE_LIST = [
  {
    code: "GLOG_MENU_MY_ORDER_LIST",
    icon: "",
    moreAccessLink: [
      "/my-orders/hcm-create",
      "/my-orders/district-create",
      "/collection-order",
    ],
  },
  {
    code: "GLOG_MENU_MANAGE_ORDER_LIST",
    icon: "",
    moreAccessLink: [
      "/manage-orders/create",
      // "/manage-orders/hcm-create",
      // "/manage-orders/district-create",
    ],
  },
  {
    code: "GLOG_MENU_MANAGE_ORDER_ACTIVE_LIST",
    icon: "",
    moreAccessLink: [
      "/manage-orders-active/create",
      // "/manage-orders-active/hcm-create",
      // "/manage-orders-active/district-create",
    ],
  },
  {
    code: "GLOG_MENU_MANAGE_TRANSFER_ORDER_LIST",
    icon: "",
    moreAccessLink: ["/manage-transfer-orders/create"],
  },
  {
    code: "GLOG_MENU_BUS_LIST",
    icon: "",
    moreAccessLink: ["/bus/create"],
  },
  {
    code: "GLOG_MENU_ROUTE_LIST",
    icon: "",
    moreAccessLink: ["/route/create"],
  },
  {
    code: "GLOG_MENU_CUSTOMER_LIST",
    icon: "",
    moreAccessLink: ["/customer/create"],
  },
  {
    code: "GLOG_MENU_USER_PROFILE_LIST",
    icon: "",
    moreAccessLink: ["/user-profile/create"],
  },
  {
    code: "GLOG_MENU_REPORT_LIST",
    icon: "",
    moreAccessLink: ["/report-management/statistic"],
  },
  {
    code: "GLOG_MENU_IMPORT_LIST",
    icon: "",
    moreAccessLink: ["/import-management/import"],
  },
  {
    code: "GLOG_MENU_HUB_LIST",
    icon: "",
    moreAccessLink: ["/hub"],
  },
  {
    code: "GLOG_MENU_ORDER_STATISTIC",
    icon: "",
    moreAccessLink: ["/order-statistic"],
  },
];

const returnIconByMenuCode = menuCode => {
  let iconMenu = "bx bx-message-rounded-x";

  const existMenu = MENU_CODE_LIST.find(x => x.code === menuCode);
  if (existMenu && existMenu !== undefined && existMenu.icon) {
    iconMenu = existMenu.icon;
  }

  return iconMenu;
};

const returnMoreAccessLink = menuCode => {
  let arrAccessLink = null;

  const existMenu = MENU_CODE_LIST.find(x => x.code === menuCode);
  if (existMenu && existMenu !== undefined && existMenu.moreAccessLink) {
    arrAccessLink = existMenu.moreAccessLink;
  }

  return arrAccessLink;
};

const MENU_CODE = {
  MENU_MANAGE_E_DOC: {
    code: "MENU_MANAGE_E_DOC",
    icon: "bx bxs-file-pdf",
  },
};

const returnImgByMenuCode = code => {
  switch (code) {
    case MENU_CODE.EDOCUMENT_MANAGEMENT.code:
      return "bx bxs-file-pdf";
    default:
      return "bx bx-message-rounded-x";
  }
};

export {
  MENU_CODE,
  MENU_CODE_LIST,
  layoutTypes,
  layoutWidthTypes,
  leftBarThemeImageTypes,
  leftSideBarThemeTypes,
  leftSidebarTypes,
  returnIconByMenuCode,
  returnImgByMenuCode,
  returnMoreAccessLink,
  topBarThemeTypes,
};
